import type { BackgroundValue } from '@elfsight/configurator-contracts';
import { isTransparentBackground } from '@elfsight/widget-ui';
import type { CalculatorSettings } from '../types';

export const renderThumbnailModeMapping = ({
  renderThumbnailMode,
  horizontalPadding,
  verticalPadding,
  background,
  borderRadius
}: CalculatorSettings) => {
  const isTransparent = isTransparentBackground(background);

  const modifiedBackground: BackgroundValue = {
    ...background,
    color: renderThumbnailMode && isTransparent ? '#fff' : background?.color
  };

  return {
    horizontalPadding,
    verticalPadding,
    background: modifiedBackground,
    borderRadius: renderThumbnailMode ? 20 : borderRadius,
    style: {
      boxShadow: renderThumbnailMode
        ? '0 6px 30px 0 rgba(0, 0, 0, 0.1)'
        : 'none'
    },
    isTransparent: isTransparentBackground(modifiedBackground)
  };
};
